import { Link } from "react-router-dom";
import { Mail, MapPin, Mic, Pencil, Phone, CalendarPlus, Home } from "lucide-react";
import { ouvrirMicro } from "@/components/shell/useDockAction";
import { useRefs } from "@/lib/referentiels";
import { TagPastille } from "./Tags";
import { valeurChamp } from "./ChampPerso";

const Rond = ({ icone: Icone, label, onClick, href, testId, jaune }) => {
  const cls = `w-12 h-12 at-pill flex items-center justify-center transition-transform duration-150 active:scale-95 ${jaune ? "at-micro" : ""}`;
  const style = jaune ? {} : { background: "var(--surface-2)" };
  return href ? <a href={href} aria-label={label} className={cls} style={style} data-testid={testId}><Icone size={18} /></a>
    : <button type="button" aria-label={label} onClick={onClick} className={cls} style={style} data-testid={testId}><Icone size={18} /></button>;
};

export const ContactCarte = ({ fiche, champs, onModifier, onPlanifier }) => {
  const refs = useRefs();
  const c = fiche.contact || {};
  const tel = (c.telephones || [])[0];
  const defs = (cible) => champs.filter((d) => d.cible === cible);
  return (
    <div className="at-card p-5 space-y-5" data-testid="contact-card">
      <div className="flex gap-2 flex-wrap">
        <Rond icone={Pencil} label="Modifier" onClick={onModifier} testId="fiche-action-edit" />
        <Rond icone={Phone} label="Appeler" href={tel ? `tel:${tel.replace(/\s/g, "")}` : undefined} onClick={() => {}} testId="fiche-action-call" />
        <Rond icone={Mail} label="E-mail" href={c.email ? `mailto:${c.email}` : undefined} onClick={() => {}} testId="fiche-action-email" />
        <Rond icone={CalendarPlus} label="Planifier" onClick={onPlanifier} testId="fiche-action-plan" />
        <Rond icone={Mic} label="Dicter" onClick={() => ouvrirMicro({ ficheId: fiche.id, ficheNom: fiche.nom })} jaune testId="fiche-action-mic" />
      </div>
      <div>
        <p className="at-label mb-1">Contact</p>
        {c.id && fiche.peut_supprimer !== undefined ? <Link to={`/contacts/${c.id}`} className="font-bold min-h-[44px] inline-flex items-center" data-testid="contact-link">{c.civilite} {c.affichage}</Link> : <p className="font-bold">{c.affichage}</p>}
        <p className="text-sm at-muted">{refs?.types_contact?.[c.type]}{c.source ? ` · ${c.source}` : ""}</p>
        {(c.telephones || []).map((t) => <a key={t} href={`tel:${t.replace(/\s/g, "")}`} className="flex items-center gap-2 text-sm min-h-[44px] font-semibold" data-testid="contact-phone-link"><Phone size={14} />{t}</a>)}
        {c.email && <a href={`mailto:${c.email}`} className="flex items-center gap-2 text-sm min-h-[44px] break-all" data-testid="contact-email-link"><Mail size={14} className="shrink-0" />{c.email}</a>}
        {(c.adresse || c.ville) && <p className="flex items-start gap-2 text-sm mt-1"><MapPin size={14} className="shrink-0 mt-0.5" />{c.adresse} {c.code_postal} {c.ville}</p>}
      </div>
      {fiche.tags.length > 0 && <div className="flex flex-wrap gap-1.5" data-testid="fiche-tags">{fiche.tags.map((t) => <TagPastille key={t.id} tag={t} />)}</div>}
      {champs.length > 0 && (
        <dl className="space-y-1.5" data-testid="fiche-custom-fields">
          {[...defs("contact").map((d) => [d, c.champs?.[d.cle]]), ...defs("fiche").map((d) => [d, fiche.champs?.[d.cle]])].map(([d, v]) => (
            <div key={d.id} className="flex justify-between gap-3 text-sm"><dt className="at-muted">{d.libelle}</dt><dd className="font-semibold text-right">{valeurChamp(d, v)}</dd></div>
          ))}
        </dl>
      )}
      <div>
        <p className="at-label mb-2">Biens</p>
        {fiche.biens.length === 0 ? <p className="text-sm at-muted">Aucun bien.</p> : fiche.biens.map((b) => (
          <div key={b.id} className="at-soft p-3 mb-2 flex gap-2 text-sm" data-testid={`bien-${b.id}`}><Home size={15} className="shrink-0 mt-0.5" /><span>{b.type_bien} · chauffage {b.chauffage.toLowerCase()}<br /><span className="at-muted">{b.adresse} {b.ville}</span></span></div>
        ))}
      </div>
    </div>
  );
};
